// @ts-ignore
import { fetcher } from "@/utils/api.ts";

function useTrackVisit(page) {
  return fetcher(`/track/${page}`, { method: "POST" });
}

export default useTrackVisit;
